import React, { useContext } from 'react';

// GLOBAL VARIABLES
import { INVENTORY_FILE_TYPE_IDS } from 'globals.js';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import Card from '../parts/Card';
import Attachment from 'routers/interface/tools/attachment/Attachment';

// MAIN COMPONENT
const MSRPForm = () => {
  const { refetchRecord } = useContext(RecordContext);

  return (
    <Form.Body>
      <Attachment.Upload
        label="MSRP Sticker/Window Sticker"
        name="inventory.documentAttachment.msrp"
        documentType={INVENTORY_FILE_TYPE_IDS.MSRP_STICKER_NEW}
        uploadType="inventory"
        onComplete={refetchRecord}
      />
    </Form.Body>
  );
};

// EXPORT
export default function MSRP({ number, ...props }) {
  const { record: initialValues = {} } = useContext(RecordContext) || {};

  return (
    <Card
      number={number}
      title="MSRP"
      color="blue"
      body={
        <Form initialValues={initialValues}>
          <MSRPForm {...props} />
        </Form>
      }
    />
  );
}
